import { useEffect } from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import { useApp } from "../../../context/AppContextProvider";
import { useAuth } from "../../../context/UserContextProvider";
import i18n from "../../../language/i18n";
import ErrorLayout from "../../../components/common/error/ErrorLayout";

const ErrorScreen = () => {
  const navigate = useNavigate();
  const error = useRouteError() as any;
  const { setBoarding, isFullScreen, setIsFullScreen } = useApp();
  const { userInformation } = useAuth();

  useEffect(() => {
    if (isFullScreen === false) {
      setIsFullScreen(true);
    }
  }, []);

  const handleClickToNavigate = async () => {
    navigate("/");
    if (userInformation) {
      setBoarding("DASHBOARD");
    } else {
      setBoarding("LANDING");
    }
  };

  return (
    <ErrorLayout
      statusCode={error?.status}
      statusText={error?.statusText}
      helpText={i18n.t("unexpected_error_help_text")}
      tone="danger"
      icon="warning"
      actionTitle={i18n.t("dashboard")}
      onAction={handleClickToNavigate}
    />
  );
};

export default ErrorScreen;
